/**
 * ProjectBulkBar.tsx — 자료수집 목록에서 골라 한꺼번에 종료 · 다시 열기 · 삭제(2026-10-27 지도사 「일일이 들어가지 않고 삭제 · 종료할 수 있게」)
 *  표 바로 위 한 줄 — 고른 수 · 단추 셋(같은 크기) · 삭제는 두 번 눌러 확정(브라우저 확인 창 없이) · 서버 POST /api/projects/bulk-action
 */
import { useEffect, useState } from 'react';
import type { CSSProperties } from 'react';

type Action = 'close' | 'reopen' | 'delete';
const NAVY = '#1B3A5C', RED = '#B42318', LINE = '#E5E7EB', SUB = '#6B7280';

export default function ProjectBulkBar({ count, closedView, busy, onAction, onClear }: {
  count: number; closedView: boolean; busy: boolean; onAction: (a: Action) => void; onClear: () => void;
}) {
  const [arm, setArm] = useState(false);
  useEffect(() => { setArm(false); }, [count]);
  useEffect(() => { if (!arm) return undefined; const t = window.setTimeout(() => setArm(false), 6000); return () => window.clearTimeout(t); }, [arm]);
  if (!count) return null;
  const btn = (danger?: boolean, on?: boolean): CSSProperties => ({
    height: 32, minWidth: 92, padding: '0 14px', borderRadius: 8, fontSize: 12.5, fontWeight: 700, cursor: busy ? 'progress' : 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap',
    border: `1.5px solid ${danger ? (on ? RED : '#F3B4B4') : '#CBD5E1'}`, background: on ? RED : '#fff', color: on ? '#fff' : danger ? RED : '#111827',
  });
  return (
    <div role="toolbar" aria-label="고른 프로젝트" style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', padding: '10px 14px', borderBottom: `1px solid ${LINE}`, background: '#F5F8FC' }}>
      <span style={{ fontSize: 13, fontWeight: 700, color: NAVY, marginRight: 4 }}>{count}건 고름</span>
      {closedView
        ? <button type="button" disabled={busy} style={btn()} onClick={() => onAction('reopen')}>다시 열기</button>
        : <button type="button" disabled={busy} style={btn()} onClick={() => onAction('close')}>종료</button>}
      <button type="button" disabled={busy} style={btn(true, arm)} onClick={() => { if (!arm) { setArm(true); return; } setArm(false); onAction('delete'); }}>
        {arm ? `한 번 더 누르면 ${count}건 삭제` : '삭제'}</button>
      <span style={{ fontSize: 12, color: SUB, flex: '1 1 200px' }}>{arm ? '올라온 서류까지 지워져요 · 되돌릴 수 없어요' : closedView ? '다시 열면 고객 링크가 다시 열려요' : '종료하면 고객 링크가 닫히고 「종료」 목록으로 가요'}</span>
      <button type="button" onClick={onClear} style={{ border: 'none', background: 'none', color: SUB, fontSize: 12.5, textDecoration: 'underline', cursor: 'pointer', fontFamily: 'inherit' }}>고르기 풀기</button>
    </div>
  );
}
